<template>
	<div class="notice">
		<indexHeader></indexHeader>
		<div class="account-wrap">
			<div class="account">
				<div>
					<div class="back-nav fColor1 ft20 clear" style="padding:10px 20px 0">
						{{$t('iesan.b_liord')}}
					</div>
				</div>
				<div class="account-content">
					<div>
						<ul class="noticeList">
							<li class="clear curPer" v-for="item in newList" :key="item.id">
								<div class="">
									<div class="">{{$t('iesan.b_zhomg')}} {{item.num}} {{item.currency_id}}   <span style="margin-left: 20px;font-size: 20px;">{{$t('iesan.b_xiaohao')}}{{item.consume}}USDT</span></div>
									<span class="fr">{{item.created_at}}</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import indexHeader from "@/view/indexHeader";
	export default {
		name: "noticeList",
		components: {
			indexHeader
		},
		data() {
			return {
				more: this.$t('td.more'),
				newList: []
			};
		},
		created() {
			var that = this;
			that.getNotice();
		},
		methods: {
			getNotice() {
				this.$http({
					url: '/api/blindbox/lists',
					method: 'get',
					data: {},
					headers: {
						'Authorization': localStorage.getItem('token')
					},
				}).then(res => {
					console.log(res.data.message)
					this.newList = res.data.message;
				})
			},
			goBefore() {
				this.$router.back(-1);
			},
			getMore() {},
			goDetail(id) {
				var id = id;
				this.$router.push({
					name: "noticeDetail",
					query: {
						id: id
					}
				});
			}
		},
	};
</script>
<style lang="scss" scoped>
	.notice {
		.account-wrap {
			.account {
				// width: 1500px;
				margin: 40px auto;
				// padding-top: 30px;
				overflow: hidden;
				// min-height: 880px;
				padding-top: 0;

				.back-nav {
					height: 40px;
					font-size: 16px;
					line-height: 40px;
				}

				.nav-after {
					display: block;
					height: 10px;
					background-color: #171c2b;
				}

				.account-content {
					width: 100%;
					min-height: 450px;
					padding: 20px 0;

					// background-color: #1a243b;
					ul {
						padding: 0 20px;
						font-size: 14px;

						li {
							border-bottom: 1px dashed #303b4b;
							height: 72px;
							padding: 10px 0 7px;
							color: #cdd6e4;
							font-size: 12px;

							>div {
								>div {
									height: 36px;
									line-height: 36px;
									font-size: 20px;
									padding-left: 10px;
								}

								span {
									color: #61688a;
									font-size: 15px;
								}
							}
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/blindorder.vue